import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { PipesModule } from "@intocare/pipes";

import { BadgeTextComponent } from "./badge-text/badge-text.component";
import { IconModule } from "../icon/icon.module";

@NgModule({
	declarations: [BadgeTextComponent],
	imports: [CommonModule, MatTooltipModule, IconModule, TranslateModule, PipesModule],
	exports: [BadgeTextComponent],
})
export class BadgeModule {}
